import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogComponent } from 'app/shared/confirm-dialog/confirm-dialog.component';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxPaginationModule } from 'ngx-pagination';
import { CoreModule } from '../core/core.module';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { LoginComponent } from './authentication/login/login.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { DirectivesModule } from './directives/directives.module';
import { EpsCommonModule } from './eps-common/eps-common.module';
import { FieldsetComponent } from './fieldset/fieldset.component';
import { FilterWindowComponent } from './filter-window/filter-window.component';
import { FooterComponent } from './footer/footer.component';
import { FormComponentsModule } from './form-components/form-components.module';
import { HeaderComponent } from './header/header.component';
import { ItemCardComponent } from './item-card/item-card.component';
import { LoadingbarComponent } from './loadingbar/loadingbar.component';
import { ModalMessageComponent } from './modal/modal-message.component';
import { SelectEmailAddressesModalComponent } from './modal/modal-select-email-addresses.component';
import { ModalComponent } from './modal/modal.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PagerComponent } from './pager/pager.component';
import { PipesModule } from './pipes/pipes.module';
import { StatusComponent } from './status/status.component';
import { SvgArrowComponent } from './svg-arrow/svg-arrow.component';
import { SvgConnectorComponent } from './svg-connector/svg-connector.component';
import { TitleComponent } from './title/title.component';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { WindowComponent } from './window/window.component';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    EpsCommonModule,
    CoreModule,
    FormComponentsModule,
    DirectivesModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    ClipboardModule,
    PipesModule,
    EpsCommonModule,
  ],
  exports: [
    AngularMaterialModule,
    EpsCommonModule,
    FooterComponent,
    HeaderComponent,
    WindowComponent,
    FormComponentsModule,
    DirectivesModule,
    NgxPaginationModule,
    ClipboardModule,
    PipesModule,
    EpsCommonModule,
    // NgbModule,

    SvgConnectorComponent,
    SvgArrowComponent,
    StatusComponent,
    TitleComponent,
    LoadingbarComponent,
    PagerComponent,
    ConfirmDialogComponent,
    ItemCardComponent,
    FilterWindowComponent,
    FieldsetComponent,
  ],
  declarations: [
    PageNotFoundComponent,
    UnsupportedBrowserComponent,
    WorkInProgressComponent,
    FooterComponent,
    HeaderComponent,
    WindowComponent,
    LoginComponent,
    LogoutComponent,
    StatusComponent,
    SvgConnectorComponent,
    SvgArrowComponent,
    ModalComponent,
    ModalMessageComponent,
    TitleComponent,
    SelectEmailAddressesModalComponent,
    LoadingbarComponent,
    PagerComponent,
    ConfirmDialogComponent,
    ItemCardComponent,
    FilterWindowComponent,
    FieldsetComponent,
  ],
})
export class SharedModule { }
